export const useAdvanced = ({ tabs, selectedTab }) => {
  const tab = tabs.find(tab => tab.value === selectedTab);

  return {
    tab,
  };
};
